import { apiClient } from './client'
import type { MarkAllReadResponse, NotificationsPage, UnreadCount } from './types'

export const fetchNotifications = async (
  page: number,
  size: number
): Promise<NotificationsPage> => {
  const response = await apiClient.get<NotificationsPage>('/api/v1/me/notifications', {
    params: { page, size },
  })
  return response.data
}

export const fetchUnreadCount = async (): Promise<UnreadCount> => {
  const response = await apiClient.get<UnreadCount>('/api/v1/me/notifications/unread-count')
  return response.data
}

export const markNotificationRead = async (notificationId: string): Promise<void> => {
  await apiClient.post(`/api/v1/me/notifications/${notificationId}/read`)
}

export const markAllRead = async (): Promise<MarkAllReadResponse> => {
  const response = await apiClient.post<MarkAllReadResponse>('/api/v1/me/notifications/read-all')
  return response.data
}
